// Accordion Alpine.js Component
document.addEventListener('alpine:init', () => {
  Alpine.data('accordion', () => ({
    // State
    openItems: new Set(),
    
    // Initialize
    init() {
      // Optional: Auto-open first item in each category
      // this.openFirstItems();
      
      // Add keyboard navigation
      this.addKeyboardNavigation();
    },
    
    // Open first item in each category (optional)
    openFirstItems() {
      const categories = this.$el.querySelectorAll('.c-accordion__category');
      categories.forEach((category, categoryIndex) => {
        const firstItem = category.querySelector('.c-accordion__item');
        if (firstItem) {
          const itemData = Alpine.$data(firstItem);
          if (itemData) {
            itemData.isOpen = true;
          }
        }
      });
    },
    
    // Add keyboard navigation support
    addKeyboardNavigation() {
      this.$el.addEventListener('keydown', (e) => {
        const focusedElement = document.activeElement;
        
        if (!focusedElement.classList.contains('c-accordion__item-header')) {
          return;
        }
        
        const headers = [...this.$el.querySelectorAll('.c-accordion__item-header')];
        const currentIndex = headers.indexOf(focusedElement);
        
        switch (e.key) {
          case 'ArrowDown':
            e.preventDefault();
            const nextIndex = (currentIndex + 1) % headers.length;
            headers[nextIndex].focus();
            break;
            
          case 'ArrowUp':
            e.preventDefault();
            const prevIndex = currentIndex === 0 ? headers.length - 1 : currentIndex - 1;
            headers[prevIndex].focus();
            break;
            
          case 'Home':
            e.preventDefault();
            headers[0].focus();
            break;
            
          case 'End':
            e.preventDefault();
            headers[headers.length - 1].focus();
            break;
        }
      });
    },
    
    // Toggle all items in a category
    toggleCategory(categoryElement) {
      const items = categoryElement.querySelectorAll('.c-accordion__item');
      const hasOpenItems = [...items].some(item => {
        const itemData = Alpine.$data(item);
        return itemData && itemData.isOpen;
      });
      
      // If any items are open, close all; otherwise open all
      items.forEach(item => {
        const itemData = Alpine.$data(item);
        if (itemData) {
          itemData.isOpen = !hasOpenItems;
        }
      });
    },
    
    // Close all items
    closeAll() {
      const items = this.$el.querySelectorAll('.c-accordion__item');
      items.forEach(item => {
        const itemData = Alpine.$data(item);
        if (itemData) {
          itemData.isOpen = false;
        }
      });
    },
    
    // Open all items
    openAll() {
      const items = this.$el.querySelectorAll('.c-accordion__item');
      items.forEach(item => {
        const itemData = Alpine.$data(item);
        if (itemData) {
          itemData.isOpen = true;
        }
      });
    }
  }));
});
